import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { HouseDataProvider } from "../../data-provider/house.dp";
import { Campaign } from "../../models/campaign.model";
import { House } from "../../models/house.model";
import { PermissionCheck } from "../../shared/permission";
import { DialogUtils } from "../../helper/dialog.helper";

let AddHouseLocationComponent = {
    selector: "vcAddHouseLocation",
    templateUrl:
        "/angular/components/people/people-add-location.component.html",
    bindings: {
        type: "=?",
    },
    controller: class AddHouseLocationController {
        // * bindings for typescript compiler *
        public type?: any;
        // ************************************

        private fabOpen: boolean = false;
        private hasAddHousePermission: boolean;
        private activeCampaign: Campaign;
        private isLeaderView: boolean;

        private $scope: any;
        private __app_type: string;
        private dialog: DialogUtils;

        private houseDataProvider: HouseDataProvider;
        private campaignDataProvider: CampaignDataProvider;
        private permissionProvider: PermissionCheck;

        constructor(
            $scope: any,
            __app_type: string,
            HouseDataProvider: HouseDataProvider,
            CampaignDataProvider: CampaignDataProvider,
            PermissionCheck: PermissionCheck,
            DialogUtils: DialogUtils
        ) {
            this.$scope = $scope;
            this.__app_type = __app_type;
            this.dialog = DialogUtils;

            this.houseDataProvider = HouseDataProvider;
            this.campaignDataProvider = CampaignDataProvider;
            this.permissionProvider = PermissionCheck;

            let essentialsMode =
                CampaignDataProvider.activeCampaign.campaignstatusid == "5";
            this.hasAddHousePermission =
                this.permissionProvider.hasPermission("ADD_HOUSE") &&
                !essentialsMode;
            this.activeCampaign = this.campaignDataProvider.activeCampaign;
            this.isLeaderView = this.__app_type == "LEADER";
        }

        openDialog(ev: any): void {
            if (this.type == "house") {
                this.openHouseDialog(ev);
            }
        }

        openHouseDialog(ev: any): void {
            this.dialog
                .show({
                    component: "vc-house-form",
                    targetEvent: ev,
                    skipHide: true,
                    clickOutsideToClose: false,
                    scope: this.$scope,
                    locals: {
                        selectedHouse: null,
                    },
                    size: "x-large",
                })
                .then((house: House) => {
                    this.houseDataProvider.addToFilteredHouses(house);
                });
        }
    },
};

angular
    .module("people")
    .component(AddHouseLocationComponent.selector, AddHouseLocationComponent);
